import { djs } from '@/lib/formatters';

export default function Copyright() {
  const currentYear = djs().format('YYYY');

  return (
    <div className="text-muted-foreground text-xs">
      © {currentYear}{' '}
      <a
        className="text-muted-foreground underline"
        href="https://grocerytv.com/"
        rel="noreferrer"
        target="_blank"
      >
        Grocery TV
      </a>{' '}
      All Rights Reserved.{' '}
      <a
        className="underline"
        href="https://grocerytv.com/terms/"
        rel="noreferrer"
        target="_blank"
      >
        Terms
      </a>{' '}
      &{' '}
      <a
        className="underline"
        href="https://grocerytv.com/privacy/"
        rel="noreferrer"
        target="_blank"
      >
        Privacy
      </a>
    </div>
  );
}
